module.exports = __webpack_public_path__ + "static/media/documents-action-plan.74bfe3c0.svg";